module.exports = __webpack_public_path__ + "assets/img/industries1.fbcdd777.png";